<template>
  <v-list-item :href="externalLink" :to="internalLink">
    <v-list-item-content>
      <v-list-item-title>
        {{ source.Targya }} - {{ source.Tartalma }}
      </v-list-item-title>
      <v-list-item-subtitle>
        <p class="d-flex align-center mb-0">
          {{ source.Felado.Nev }}
          <span class="dot-separator grey darken-2 mx-2"></span>
          <k-live-timestamp :value="source.Datum"></k-live-timestamp>
        </p>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-ertesites-lista-item',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    externalLink() {
      let kulsoLink = this.source.KulsoLink || '';
      if (!kulsoLink || !kulsoLink.startsWith('http')) {
        return '';
      }
      return kulsoLink;
    },
    internalLink() {
      let belsoLink = this.source.BelsoLinkId || '';
      let kulsoLink = this.source.KulsoLink;
      if (!belsoLink || kulsoLink) {
        return '';
      }
      return { name: 'Hir', params: { id: belsoLink } };
    },
  },
  watch: {},
  props: {
    index: {
      type: Number,
    },
    source: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
